// Integrazioni esterne del cliente precedente: spente.
//
// Gli indirizzi NON stanno piu' qui. Erano cablati e puntavano agli account
// del cliente precedente, quindi un utente che premeva il pulsante finiva
// dentro il suo spazio sul servizio esterno. Ora arrivano dal backend
// (`GET /api/v1/config/integrations`, vedi lo store `config`), che li espone
// solo se l'integrazione e' configurata.
//
// Il controllo va fatto SEMPRE sullo stato dell'integrazione e non solo sul
// permesso: i Super Utenti scavalcano ogni permesso, quindi vedrebbero
// comunque i pulsanti.
//
// Dettagli e problemi noti in `docs/integrazioni-disattivate.md`.

export interface IntegrationState {
  enabled: boolean;
  url?: string | null;
  calculatorUrl?: string | null;
}

export interface IntegrationsState {
  eturnity: IntegrationState;
  ecobonusCheck: IntegrationState;
  mavigex: IntegrationState;
  financingPortal: IntegrationState;
}

// Stato di partenza: tutto spento. Se la chiamata al backend non e' ancora
// tornata, i punti d'ingresso restano nascosti invece di comparire e sparire.
export const INTEGRATIONS_DISABLED: IntegrationsState = {
  eturnity: { enabled: false, calculatorUrl: null },
  ecobonusCheck: { enabled: false, url: null },
  mavigex: { enabled: false },
  financingPortal: { enabled: false, url: null },
};
